<template>
    <div id="dmList">

        <div class="row">
            <div class="dm-left-container" style="text-align: left;">
                <div class="parent-dm-list-container">

                    <div class="row" style="margin: 10px 0px; padding: 15px;">
                        <span class="sans-font-style-size-18" style="margin-left: 10px;">List</span>
                    </div>

                    <hr style="margin: 0px;" />

                    <div style="overflow: auto; height: calc(100vh - 170px);">
                        <div class="row each-parent-dm-container" :class="person.CONid === selectedPersonID ? 'active' : ''"
                             v-for="(person, perIndex) in arrobj_historyPersonDMList"
                             style="margin: 0px; padding: 10px 20px; border-bottom: 1px solid #eee;" @click="changePersonChat(person)">

                            <div class="each-parent-dm">
                                <span>{{person.CONname}}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="dm-content-container">
                <div class="dm-header-container" style="text-align: left; margin-bottom: 20px;">
                    <i class="fa fa-envelope" style="font-size: 18px;" aria-hidden="true"></i>
                    <span class="sans-font-style-size-18" style="margin-left: 10px;">Message</span>
                </div>

                <div class="dm-body-container"
                     style="background: white; max-height: calc(100vh - 70px); overflow:auto; min-height: calc(100vh - 170px);
                     padding: 20px; margin-bottom: 20px;">

                    <div v-if="Object.keys(arrobj_dmMsgList).length > 0">
                        <div class="container each-dm-groupby-date-container"
                             v-for="(msgItem, msgIndex) in arrobj_dmMsgList">

                            <div class="dm-date-container" style="position: relative; margin-bottom: 20px;">
                                <hr/>
                                <span style="position: absolute; top: -10px; left: 40%; background: white;">{{msgIndex}}</span>
                            </div>

                            <div class="container each-msg-container" :class="currentUserID === eachItem.PostDMFromConID ? 'me' : 'user'"
                                 v-for="(eachItem, eachIndex) in msgItem">
                                <div v-if="eachItem.dmPostLink" @click="referDMPost(eachItem.dmSinglePost)"
                                     :class="eachItem.dmPostLink ? 'noBackgroudColor' : ''">
                                    <span v-html="eachItem.PostDMMsg">
<!--                                        <a @click="referDMPost(eachItem.PostDMMsg)" target="_blank">-->
                                        <!--                                        </a>-->
                                    </span>
                                </div>

                                <div v-else :class="!eachItem.dmPostLink ? 'withBackgroudColor' : ''">
                                    <img src="../assets/boy.png" v-if="currentUserID === eachItem.PostDMFromConID">
                                    <img src="../assets/user-1.png" v-if="currentUserID !== eachItem.PostDMFromConID">
                                    <p style="margin: 0px;"><span>{{eachItem.PostDMMsg}}</span></p>
                                    <span>{{eachItem.PostDMCreatedOn_convertTime}}</span>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div v-if="arrobj_dmMsgList.length <= 0">
                        <div class="empty-notification-container">
                            <img src="../assets/notif1.png" style="margin: 0 auto;"/>
                            <span style="display: block; margin: 0 auto;">{{notif_empty_message}}</span>
                        </div>
                    </div>

                </div>

                <div class="dm-footer-container">
                    <div class="input-group">
                        <input class="form-control" v-model="dmMsgContent"
                               type="text" placeholder="Please enter message" style="" />
                        <div class="input-group-append" style="cursor: pointer;" @click="submitComment()">
                            <span class="btn btn-dm-submit-icon"
                                  style="background: #426DFF; color: #ffffff;">
                                <i class="fa fa-paper-plane"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import Vue from 'vue';
    import Cookies from "js-cookie";
    import moment from 'moment';
    import {lang} from '../locale/index';
    import $ from 'jquery';

    export default {
        name: "StaffDM",
        components: {
        },
        data() {
            return {
                checkMobileStatus: false,

                arrobj_dmMsgList: [],
                arrobj_historyPersonDMList: [],
                value: {},

                notif_empty_message: lang("Notif Empty Message"),
                dmMsgContent: "",
                selectedPersonID: "",
                currentUserID: "",
                currentBaseUrl: "",
            };
        },
        async created() {
            this.currentUserID = Cookies.get('userIDSession');
            if (Cookies.get('userTypeSession') === "Parent") {
                this.currentBaseUrl = process.env.VUE_APP_ROOT_API4+':8081';
            } else {
                this.currentBaseUrl = process.env.VUE_APP_ROOT_API3+':8081';
            }

            await this.getDMHistoryChat();
            await this.scrollToBottom();

            window.addEventListener('resize', this.isMobile);
        },
        destroyed () {
            window.removeEventListener('resize', this.isMobile);
        },
        methods: {
            lang,

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },

            async submitComment() {
                if (this.dmMsgContent === "") {
                    return;
                }

                try {
                    const dmResponse = await DataSource.shared.savePostDM('', this.selectedPersonID, this.dmMsgContent, '');

                    if (dmResponse) {
                        if (dmResponse.code === "2") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'No record found'
                            });
                        } else if (dmResponse.code === "88") {
                            window.location.replace('/');
                        } else if (dmResponse.code === "99") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Please try again later'
                            });
                        } else {
                            this.$notify({
                                title: lang('Success'),
                                message: 'Message send successful!',
                                type: 'success'
                            });

                            await this.getDMPersonChat();
                            await this.scrollToBottom();
                        }
                    }

                    this.dmMsgContent = "";

                } catch (e) {
                    console.log(e);
                }
            },

            async getDMHistoryChat() {
                this.arrobj_historyPersonDMList = [];

                try {
                    this.$vs.loading();

                    const response = await DataSource.shared.getDMHistoryChat();

                    if (response) {
                        if (response.code === "2") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'No record found'
                            });
                        } else if (response.code === "88") {
                            window.location.replace('/');
                        } else if (response.code === "99") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Please try again later'
                            });
                        } else {
                            if (response.Table) {
                                this.arrobj_historyPersonDMList = response.Table;
                                this.changePersonChat(this.arrobj_historyPersonDMList[0]);
                                // this.getDMPersonChat();
                            }
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },

            changePersonChat(val) {
                this.selectedPersonID = val.CONid;
                this.getDMPersonChat();
            },

            async getDMPersonChat() {
                this.arrobj_dmMsgList = [];

                try {
                    this.$vs.loading();

                    const response = await DataSource.shared.getDMPersonChat(this.selectedPersonID);

                    if (response) {
                        if (response.code === "2") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'No record found'
                            });
                        } else if (response.code === "88") {
                            window.location.replace('/');
                        } else if (response.code === "99") {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Please try again later'
                            });
                        } else {
                            if (response.Table) {
                                let dmPostLink = "";
                                response.Table.forEach(object => {
                                    object.dmPostLink = false;
                                    if (object.PostDMMsg.includes("<div")) {
                                        // object.PostDMMsg = this.currentBaseUrl+object.PostDMMsg;
                                        dmPostLink = object.PostDMMsg; // this.currentBaseUrl+
                                        object.dmPostLink = true;
                                        object.dmSinglePost = "/StaffMainPage?postID="+object.PostDMPostID;
                                    }
                                });

                                this.arrobj_dmMsgList = response.Table;
                                this.arrobj_dmMsgList = this.groupBy(this.arrobj_dmMsgList, "PostDMCreatedOn_convert");
                            }
                        }
                    }

                    this.$vs.loading.close();
                } catch (e) {
                    this.results = e;
                }
            },

            groupBy(array, key) {
                const result = {}
                array.forEach((item, index) => {
                    if (!result[item[key]]){
                        result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                })
                return result;
            },

            scrollToBottom() {
                $('.dm-body-container').animate({ scrollTop: $(".dm-body-container").height() }, 'slow');
            },

            referDMPost(link) {
                window.open(link);
                // window.location.replace(link);
            },
        },
        mounted() {
            this.selectedPersonID = "";
            if (!this.isNull(this.dmParamData)) {
                this.selectedPersonID = this.dmParamData[0].NotiCreatedBy;
            }

            const self = this;
            self.isMobile();
            // self.scrollToBottom();

            $(document).ready(function(){
                // $('.dm-body-container').animate({ scrollTop: $(".dm-body-container").height() }, 'slow');
            });
        },
        props: ["dmParamData"],
    }
</script>

<style scoped>
    .dm-left-container {
        width: 25%;
        display: inline-block;
        background: white;
        position: sticky;
        top: 0px;
        border-radius: 8px;
        vertical-align: top;
        align-self: flex-start;
        min-height: calc(100vh - 70px);
    }

    .dm-content-container {
        margin: 0 auto;
        width: 50%; /* 65%*/
    }

    .each-parent-dm-container.active {
        background: #426DFF;
        color: white;
    }

    .each-msg-container .withBackgroudColor {
        padding: 20px;
        background: #eee;
        border-radius: 8px;
        margin-bottom: 15px;
    }

    .each-msg-container.me {
        text-align: right;
    }

    .each-msg-container.user {
        text-align: left;
    }

    .each-msg-container img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        float: left;
    }

    .each-msg-container.me img {
        float: right;
        margin-left: 20px;
    }

    .each-msg-container.user img {
        float: left;
        margin-right: 20px;
    }

    .mobile-view #dmList .row {
        margin: 0px;
    }

    .mobile-view .dm-content-container {
        width: 100%;
    }

    .mobile-view .dm-left-container {
        width: 100%;
    }

    .sans-font-style-size-18 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 22px;
    }


    .total-reaction-img-list {
        width: 20px;
    }
</style>